// extracted by mini-css-extract-plugin
export var copywrightcontainer = "styles-module--copywrightcontainer--t8RVq";
export var footer = "styles-module--footer--Bsf-Q";
export var leftside = "styles-module--leftside--gr1cq";
export var linkcontainer = "styles-module--linkcontainer--txFCU";
export var links = "styles-module--links--t6klr";
export var ref = "styles-module--ref--JKMbn";
export var reflink = "styles-module--reflink--kfBHi";
export var rightside = "styles-module--rightside--j4u1N";
export var sep = "styles-module--sep--IAucf";